import React from 'react';
import AdminDashboard from '../AdminDashboard';

const VendorsPage = () => <AdminDashboard forcedTab="vendors" embedded />;

export default VendorsPage;
